import { gql, useApolloClient, useLazyQuery, useQuery } from "@apollo/client";
import { WBBox } from "@apptractive/design-system-web";
import { Auth } from "aws-amplify";
import { useEffect, useMemo } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { isLoggedInVar } from "../customGraphql/cache";
import { CSIsLoggedIn as IS_LOGGED_IN } from "../customGraphql/queries";
import { getUser as GET_USER } from "../graphql/queries";
import { getOnboardingPath } from "../helpers/onboarding";
import { PATHS } from "../navigation/paths";
import { ChangeLanguage } from "./ChangeLanguage";
import { NavBar } from "./common";

const OnboardingLayout = () => {
  const navigate = useNavigate();
  const client = useApolloClient();
  const [getUser, { data: userData }] = useLazyQuery(gql(GET_USER));
  const { data: loggedInData } = useQuery(gql(IS_LOGGED_IN));
  const isLoggedIn = useMemo(() => loggedInData?.isLoggedIn, [loggedInData]);

  const user = useMemo(() => userData?.getUser || {}, [userData]);
  const path = useMemo(() => getOnboardingPath(user), [user]);

  useEffect(() => {
    const checkUserSession = async () => {
      try {
        const curUser = await Auth.currentAuthenticatedUser({
          bypassCache: true,
        });
        if (curUser?.attributes?.sub) {
          localStorage.setItem("sub", curUser.attributes.sub as string);

          await getUser({
            variables: {
              id: curUser.attributes.sub,
            },
          });
        }
      } catch (err) {
        console.log("ERROR: Auth.currentAuthenticatedUser", err);
        localStorage.removeItem("sub");
        isLoggedInVar(false);
        client.cache.evict({ fieldName: "me" });
        client.cache.gc();
      }

      if (isLoggedIn === false) {
        navigate(PATHS.signIn, { replace: true });
      }
    };

    checkUserSession();
  }, [client, navigate, isLoggedIn, getUser]);

  return (
    <WBBox>
      <NavBar homePath={path} navRight={<ChangeLanguage />} />
      <Outlet />
    </WBBox>
  );
};

export default OnboardingLayout;
